export class Country {
  static readonly NI = 'NI';
  static readonly GT = 'GT';
}
